const normalizeByNumberOfDays = (
  weeklyWeight?: number,
  numberOfDaysInWeek?: number,
  consecutiveNumberOfDays?: number,
  numberOfWeeks?: number
) => {
  if (consecutiveNumberOfDays && numberOfWeeks) {
    return (
      (((weeklyWeight ?? 0) * numberOfWeeks) / (7 * numberOfWeeks)) *
      consecutiveNumberOfDays
    );
  }

  return ((weeklyWeight ?? 0) / 7) * (numberOfDaysInWeek ?? 0);
};

export default normalizeByNumberOfDays;
